import AppFooter from "../../components/AppFooter";
import { useAuth } from "../../contexts/AuthInfoContext";
import { usePrivate } from "../../contexts/PrivateInfoContext";
import "./styles.scss";
//import { Tooltip } from "primereact/tooltip";
import { addDays, addMonths, differenceInDays, format, sub } from "date-fns";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { OverlayPanel } from "primereact/overlaypanel";
import { Paginator } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import { SelectButton } from "primereact/selectbutton";
import { Tag } from "primereact/tag";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { BsCheckAll } from "react-icons/bs";
import {
  FaBarcode,
  FaChartPie,
  FaCreditCard,
  FaHandshake,
  FaMoneyBill,
  FaQuestionCircle,
  FaRegCreditCard,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AtualizarDadosDialog from "../../components/AtualizarDadosDialog";
import BandeiraCartaoDialog from "../../components/BandeiraCartaoDialog";
import CartaoCreditoDialog from "../../components/CartaoCreditoDialog";
import CartaoCreditoLinkDialog from "../../components/CartaoCreditoLinkDialog";
import { criaColunasCobrancas } from "../../components/Columns";
import ConstestacaoDialog from "../../components/ContestacaoDialog";
import DetalhesDialog from "../../components/DetalhesDialog";
import DialogAvenida from "../../components/DialogAvenida";
import DialogConfirmacaoAvenida from "../../components/DialogConfirmacaoAvenida";
import DialogConfirmacaoDias from "../../components/DialogConfirmacaoDias";
import DialogNegociadas from "../../components/DialogNegociadas";
import DialogOferta from "../../components/DialogOferta";
import DialogParcialProtestada from "../../components/DialogParcialProtestada";
import DownloadBoletoDialog from "../../components/DownloadBoletoDialog";
import NotificacaoDialog from "../../components/NotificacaoDialog";
import { ProtestadoDialog } from "../../components/ProtestadoDialog";
import ProtestoDialog from "../../components/ProtestoDialog";
import ProviderSelector from "../../components/ProviderSelect";
import QuickMenu from "../../components/QuickMenu";
import SimpleLoading from "../../components/SimpleLoading";
import TermoDialog from "../../components/TermoDialog";
import TutorialDialog from "../../components/TutorialDialog";
import { useGeneral } from "../../contexts/GeneralInfoContext";
import { useNegotiation } from "../../contexts/NegotiationContext";
import { formatCurrency } from "../../utils/FormatCurrency";
import { getLocal, setLocal } from "../../utils/LocalStorageOps";
import ErrorPage from "../ErrorPage";

import slide1 from "../../assets/tutorial/1.webp";
import slide2 from "../../assets/tutorial/2.webp";
import slide3 from "../../assets/tutorial/3.webp";
import AtualizarEnderecoDialog from "../../components/AtualizarEnderecoDialog";

//import classNames from 'classnames';

function Dashboard() {
  const {
    today,
    corGradiente1,
    corGradiente2,
    corGradiente3,
    corCard1,
    corCard2,
    corFonte,
    corFonte2,
    mostrarFooter,
    logoImage,
    tituloPagina,
    pagueDiretoLogo,
    iconePagina,
    erroConexaoBackEnd,
  } = useGeneral();
  const { provider, user, multiploProvider } = useAuth();
  const {
    devedorInfo,
    valorOriginal,
    valorAPagar,
    juros,
    multa,
    indice,
    valorBaixa,
    desconto,
    descontoTipo,
    descontoAplicavel,
    descontoMaxParcelas,
    checaDesconto,
    mudaFormaPagamento,
    tipoPagamento,
    servicos,
    tipoFeeProtesto,
    valorFeeProtesto,
    valorComDesconto,
    loading,
    //taxa_zoop,
    cobrancas,
    countCobrancas,
    firstCobrancas,
    protestoStatus,
    taxaEnvioProtesto,
    mudaPagina,
    negociadas,
    parcelas,
    parcelaValor,
    parcelasDescontoParcelas,
    valorAPagarDescontoParcelas,
    boletoVencimentoParcelas,
    boletoVencimentoParcelasValor,
    checaDescontoBoleto,
    entradaAceite,
    cartaoBandeira,
    entradaMinima,
    entrada,
    taxaPagueEntrada,
    setEntrada,
    adicionaEntrada,
    limpaEntrada,
    setTaxaPague,
    negociavelAvenida,
    providerAvenida,
    oferta,
    providerWlan,
    protestadas,
    notificacoes,
    providerCREF,
    providerCREFDF,
    quebrada,
    textoConsumidor,
    boletoVencimento,
    setBoletoVencimento,
    bloqueioCartao,
    cobrancas_memo,
    cobrancasSelecionadas,
    setCobrancasSelecionadas,
    processaInfo,
    valoresNegociacaoParcial,
    setDescontoAplicavel,
    travaNegociacaoTotal,
    tipoNegociacao,
    setTipoNegociacao,
    taxaPrimeiraParcelaProtesto,
    negociacaoParcial,
    escolheVencimento,
    maxVencimento,
    enderecoAtualizado
  } = usePrivate();
  const {
    aceitaProtesto,
    aceitaProtestoParcial,
    mostraTermo,
    setMostraTermo,
    aceitaTermo,
    cartaoValidacao,
    mostraCartaoCreditoDialog,
    setMostraCartaoCreditoDialog,
    mostraCartaoCreditoLinkDialog,
    setMostraCartaoCreditoLinkDialog,
    mostraDownloadBoletoDialog,
    setMostraDownloadBoletoDialog,
    mostraConfirmacaoDias,
    setMostraConfirmacaoDias,
    pagamentoBoleto,
    mostraAtualizaEndereco, 
    setMostraAtualizaEndereco
  } = useNegotiation();
  const navigate = useNavigate();
  const entrada_overlay = useRef();

  const [formaPagamentoAlerta, setFormaPagamentoAlerta] = useState(false);
  const [seletorCredor, setSeletorCredor] = useState(multiploProvider);
  const [mostraAtualizaDados, setMostraAtualizaDados] = useState(false);
  const [mostraNegociadas, setMostraNegociadas] = useState(false);
  const [mostraProtesto, setMostraProtesto] = useState(false);
  const [mostraProtestoParcial, setMostraProtestoParcial] = useState(false);
  const [cobrancaDetalhada, setCobrancaDetalhada] = useState([]);
  const [mostraBandeiraCartaoDialog, setMostraBandeiraCartaoDialog] = useState(false);
  const [mostraDetalhesDialog, setMostraDetalhesDialog] = useState(false);
  const [mostraProtestadoDialog, setMostraProtestadoDialog] = useState(false);
  const [mostraNotificacaoDialog, setMostraNotificacaoDialog] = useState(false);
  const [notificacaoLida, setNotificacaoLida] = useState(false);
  const [mostraInegociavelAvenida, setMostraInegociavelAvenida] = useState(false);
  const [mostraConfirmacaoAvenida, setMostraConfirmacaoAvenida] = useState(false);
  const [mostraOferta, setMostraOferta] = useState(false);
  const [mostraTutorial, setMostraTutorial] = useState(false);
  const [mostraContestacao, setMostraContestacao] = useState(false);
  //const [limitePopup,setLimitePopup] = useState(0);
  const [cronograma, setCronograma] = useState([]);

  const [showSlides, setShowSlides] = useState(false);
  const sliderImages = [slide1, slide2, slide3];

  const [possuiNotificacao, setPossuiNotificacao] = useState(false);
  const [ordemPopUps, setOrdemPopUps] = useState([]);
  const [popUpAtual, setPopUpAtual] = useState(null);
  const [tutorialMostrado, setTutorialMostrado] = useState(false);
  const [protestoMostrado, setProtestoMostrado] = useState(false);
  const [erroData, setErroData] = useState("");
  const [digitando, setDigitando] = useState(false);
  const [dataCalendar, setDataCalendar] = useState(addDays(today, 1));

  const handleDataChange = (e) => {
    setDigitando(true);
    setBoletoVencimento(differenceInDays(e.value, today));
    setDataCalendar(e.value);
  };

  const handleBlur = () => {
    setDigitando(false);

    if (!dataCalendar || isNaN(new Date(dataCalendar).getTime())) {
      setErroData("Data inválida. Ajustada para amanhã.");
      setDataCalendar(addDays(today, 1));
      setBoletoVencimento(1);
    } else {
      setErroData("");
    }
  };

  useEffect(() => {
    if (erroData) {
      const timer = setTimeout(() => {
        setErroData("");
      }, 5000);

      return () => clearTimeout(timer); // evita memory leak
    }
  }, [erroData]);

  const mostraDescontoVencimentoBoleto =
    boletoVencimentoParcelas.length > 0 &&
    tipoPagamento === "B" &&
    Number(parcelaValor.numero_parcela) <= descontoMaxParcelas &&
    descontoTipo === "boleto";
  // const fundoClasses = classNames(corGradiente1,corGradiente2,corGradiente3, "bg-gradient-to-tl h-full md:h-screen xl:pb-[4.2vh] lg:pb-[6vh] md:pb-[7vh] pb-[9.5vh] px-[1vh] grid lg:flex overflow-x-hidden md:ml-0 -ml-[1vh]",corFonte,"font-lato-bold ")

  //const repetido = getLocal('CartaoRepetido')
  const tipoPagamentoOptions = [
    {
      label: "Boleto",
      value: "B",
      icon: <FaBarcode />,
      disabled: valorAPagar < 10 && cobrancas.length > 0,
    },
    {
      label: "Cartão",
      value: "C",
      icon: <FaRegCreditCard />,
      disabled: valorAPagar < 10,
    },
  ];

  const tipoNegociacaoOptions = [
    {
      label: "Total",
      value: "total",
      icon: <BsCheckAll />,
      disabled: travaNegociacaoTotal,
    },
    { label: "Parcial", value: "parcial", icon: <FaChartPie /> },
  ];
  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener, noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const botaoTipoPagamento = (option) => {
    return (
      <div className={`flex justify-between w-full ${option.className}`}>
        <h6>{option.label}</h6>
        <i style={{ fontSize: "3vh" }}>{option.icon}</i>
      </div>
    );
  };

  const botaoDetalhes = (rowData) => {
    return (
      <div className="infoButton">
        <Button icon="pi pi-info-circle" onClick={() => abreDetalhes(rowData)}></Button>
      </div>
    );
  };

  function abreDetalhes(rowData) {
    setCobrancaDetalhada(rowData);
    setMostraDetalhesDialog(true);
  }

  function sair() {
    localStorage.clear();
    navigate("/");
  }

  function totalPagar() {
    //console.log(entrada,descontoAplicavel)
    if (cobrancas.length > 0) {
      if (entrada) {
        //if (providerAvenida || (providerWlan && tipoPagamento === 'B')){
        //console.log(parcelaValor,entrada)
        const total_a_pagar =
          Number(parcelaValor.valor_parcela) * (Number(parcelaValor.numero_parcela) - 1) +
          Number(entrada) +
          (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0);
        return total_a_pagar;
      } else {
        if (descontoAplicavel) {
          if (descontoTipo === "parcela") {
            const total_a_pagar = valorAPagarDescontoParcelas + (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0);
            return total_a_pagar;
          } else if (descontoTipo === "boleto") {
            const total_a_pagar = valorAPagarDescontoParcelas + (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0);
            return total_a_pagar;
          } else if (descontoTipo === "tempo") {
            const total_a_pagar =
              parcelaValor.valor_parcela * parcelaValor.numero_parcela +
              (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0);
            return total_a_pagar;
          } else if (descontoTipo === "porcento") {
            const total_a_pagar =
              parcelaValor.valor_parcela * parcelaValor.numero_parcela +
              (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0);
            return total_a_pagar;
          }
        } else {
          const total_a_pagar =
            Number(parcelaValor.valor_parcela) * Number(parcelaValor.numero_parcela) +
            Number(entrada) +
            taxaPagueEntrada +
            (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0);
          return total_a_pagar;
        }
      }
    } else return "-";
  }

  function taxaPague() {
    //console.log(descontoAplicavel,descontoTipo, parcelaValor, valorAPagar, entrada)
    if (cobrancas.length > 0) {
      if (descontoAplicavel && !entrada) {
        if (descontoTipo === "parcela" || descontoTipo === "boleto") {
          const taxa_pague = valorAPagarDescontoParcelas - valorComDesconto;
          setTaxaPague(taxa_pague);
          return taxa_pague;
        } else if (descontoTipo === "tempo" || descontoTipo === "porcento") {
          const taxa_pague =
            parcelaValor.valor_parcela * parcelaValor.numero_parcela - valorComDesconto + entrada + taxaPagueEntrada;
          setTaxaPague(taxa_pague);
          return taxa_pague;
        }
      } else {
        if (!entrada) {
          const taxa_pague = parcelaValor.valor_parcela * parcelaValor.numero_parcela - valorAPagar;
          setTaxaPague(taxa_pague);
          return taxa_pague;
        } else {
          const taxa_pague =
            parcelaValor.valor_parcela * (parcelaValor.numero_parcela - 1) + Number(entrada) - valorAPagar;
          //console.log(parcelaValor.valor_parcela * (parcelaValor.numero_parcela-1),entrada,valorAPagar)
          setTaxaPague(taxa_pague);
          return taxa_pague;
        }
      }
    } else return "-";
  }

  function continuarNegociacao() {
    const cronograma_array = criarCronograma();
    setCronograma(cronograma_array);
    if (enderecoAtualizado){
      if (protestoStatus) {
        if (tipoNegociacao === "parcial") setMostraProtestoParcial(true);
        else setMostraProtesto(true);
      } else {
        if (providerAvenida) {
          setMostraConfirmacaoAvenida(true);
        } else setMostraTermo(true);
      }
    } else setMostraAtualizaEndereco(true)
  }

  function criarCronograma() {
    let calendarioPagamento = [];
    console.log(parcelaValor, parcelas, parcelasDescontoParcelas);
    for (let i = 0; i < parcelaValor.numero_parcela; i++) {
      let valor = descontoAplicavel
        ? formatCurrency(parcelasDescontoParcelas.valor_parcela)
        : formatCurrency(parcelaValor.valor_parcela);
      if ((taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0) > 0 && i === 0)
        valor = descontoAplicavel
          ? formatCurrency(
            Number(parcelasDescontoParcelas.valor_parcela) + (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0)
          )
          : formatCurrency(Number(parcelaValor.valor_parcela) + (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0));
      calendarioPagamento.push({
        parcela: i + 1,
        valor,
        dia_pagamento: format(addMonths(addDays(new Date(), boletoVencimento), i), "dd/MM/yyyy"),
      });
    }
    return calendarioPagamento;
  }

  function verificaData(data) {
    const hojeMenos2Meses = sub(new Date(), { days: 60 });
    const atualizadoEm = new Date(data);

    const subtracao = atualizadoEm - hojeMenos2Meses;

    return subtracao <= 0;
  }

  function mudaSelecao(e) {
    //console.log("MUDA SELEÇÃO :::",e)
    setCobrancasSelecionadas(e.value);
    valoresNegociacaoParcial(e.value);
    setDescontoAplicavel(false);
    mudaFormaPagamento(null);
    //checaProtesto(e.value);
  }

  function checaMaisAntiga(e) {
    const array_selecionadas = cobrancasSelecionadas;
    //console.log("ARRAY:::", array_selecionadas)
    const hist_cobrancas = cobrancas_memo.current;

    if (!e.data.disponivel_parcial) return false;
    if (tipoNegociacao === "total") return false;
    if (hist_cobrancas.length === 0) return false;

    const nao_protestadas = hist_cobrancas.filter((cob) => {
      return cob.protesto_status !== "ENVIADO";
    });

    if (e.data.protesto_status === "ENVIADO") return false;

    const [mais_atinga] = nao_protestadas.sort((a, b) => {
      return b.dias - a.dias;
    });

    if (array_selecionadas.length === 0) {
      //console.log("PRIMEIRO IF")
      //console.log("MAIS ANTIGA :::",mais_atinga)
      if (mais_atinga.dias === e.data.dias) return true;
      else return false;
    }

    const [mais_recente_selecionada] = array_selecionadas.sort((a, b) => {
      return a.dias - b.dias;
    });
    const [proxima_mais_atinga] = nao_protestadas.filter((cob) => {
      return cob.dias <= mais_recente_selecionada.dias && cob.cobranca_id !== mais_recente_selecionada.cobranca_id;
    });

    //console.log("MAIS ANTIGA::", mais_atinga.dias)
    //console.log("MAIS RECENTE SELECIONADA::", mais_recente_selecionada.dias)
    //console.log("PROXIMA MAIS ANTIGA::", proxima_mais_atinga.dias)
    //console.log("COBRANCA_ID RECENTE :::",mais_recente_selecionada.cobranca_id, e.data.cobranca_id)
    if (mais_recente_selecionada.cobranca_id === e.data.cobranca_id) {
      //console.log("SEGUNDO IF")
      return true;
    }

    if (!proxima_mais_atinga) {
      return false;
    }

    if (proxima_mais_atinga.dias === e.data.dias) {
      //console.log("TERCEIRO IF")
      return true;
    }
    //console.log("QUARTO IF")
    return false;
  }

  function alertaIndisponivel(e) {
    const { data } = e;
    console.log(data);
    if (tipoNegociacao === "total") return null;
    if (!data.disponivel_parcial) {
      abreDetalhes(data);
      return toast.warn("Cobrança indisponível para negociação");
    }
    if (data.protesto_status === "ENVIADO") {
      abreDetalhes(data);
      return toast.warn("Cobrança indisponível para negociação parcial");
    }
  }

  useEffect(() => {
    // console.log('=== DEBUG TUTORIAL ===');
    // console.log('negociacaoParcial:', negociacaoParcial);
    // console.log('tutorialMostrado:', tutorialMostrado);
    // console.log('mostraTutorial:', mostraTutorial);
    // console.log('popUpAtual:', popUpAtual);
    // console.log('ordemPopUps:', ordemPopUps);
  }, [negociacaoParcial, tutorialMostrado, mostraTutorial, popUpAtual, ordemPopUps]);

  useEffect(() => {
    setNotificacaoLida(false);
  }, [notificacoes]);

  useEffect(() => {
    setProtestoMostrado(false);
  }, [protestadas]);

  useEffect(() => {
    const limitePopup = getLocal("limite-popup");
    const novaOrdem = [];

    // 1. Notificações
    const notificacoesArray = Array.isArray(notificacoes) ? notificacoes : [];
    const notificacoesValidas = notificacoesArray.filter((notif) => {
      if (!notif || Object.keys(notif).length === 0) return false;
      const desativado = notif.desativar === true || String(notif.desativar).toLowerCase() === "true";
      return !desativado;
    });
    const temNotificacoes = notificacoesValidas.length > 0;

    setPossuiNotificacao(temNotificacoes);

    if (temNotificacoes && !notificacaoLida) {
      novaOrdem.push("notificacao");
    }

    // 2. Protestos
    if (protestadas.length > 0 && !protestoMostrado) {
      novaOrdem.push("protesto");
    }

    // 3. Tutorial - SÓ adiciona se todas as condições forem verdadeiras
    if (negociacaoParcial && !tutorialMostrado && cobrancas.length > 0) {
      novaOrdem.push("tutorial");
    }

    // 4. Atualizar Dados
    if (devedorInfo && limitePopup === "0" && !providerAvenida) {
      if (devedorInfo.usuario_updated === null) {
        novaOrdem.push("atualizarDados");
      } else {
        const hasExpired = verificaData(devedorInfo.usuario_updated);
        if (!hasExpired) {
          novaOrdem.push("atualizarDados");
        }
      }
    }

    // CORREÇÃO: Só atualiza se a ordem realmente mudou
    if (JSON.stringify(ordemPopUps) !== JSON.stringify(novaOrdem)) {
      setOrdemPopUps(novaOrdem);

      if (process.env.NODE_ENV === "development") {
        console.log("Nova ordem definida:", novaOrdem);
      }

      // Só mostra popup se não há um atualmente
      if (novaOrdem.length > 0 && !popUpAtual) {
        const primeiroPopUp = novaOrdem[0];
        setPopUpAtual(primeiroPopUp);
        // Pequeno delay para evitar o warning do React
        setTimeout(() => {
          abrirPopUpEspecifico(primeiroPopUp);
        }, 0);
      }
    }

    setLocal("limite-popup", 1);
  }, [protestadas, devedorInfo, notificacoes, notificacaoLida, negociacaoParcial, tutorialMostrado, cobrancas.length]);

  const abrirPopUpEspecifico = (tipo) => {
    console.log("Abrindo popup:", tipo);

    // Fechar todos os pop-ups antes de abrir o novo
    setMostraNotificacaoDialog(false);
    setMostraProtestadoDialog(false);
    setMostraTutorial(false);
    setMostraAtualizaDados(false);

    switch (tipo) {
      case "notificacao":
        setMostraNotificacaoDialog(true);
        break;
      case "protesto":
        setMostraProtestadoDialog(true);
        break;
      case "tutorial":
        setMostraTutorial(true);
        break;
      case "atualizarDados":
        setMostraAtualizaDados(true);
        break;
      default:
        break;
    }
  };

  const fecharPopUpAtual = () => {
    console.log("Fechando popup atual:", popUpAtual);

    if (popUpAtual === "tutorial") {
      setTutorialMostrado(true);
      console.log("Tutorial marcado como mostrado");
    }

    // Fecha o atual
    switch (popUpAtual) {
      case "notificacao":
        setMostraNotificacaoDialog(false);
        setNotificacaoLida(true);
        break;
      case "protesto":
        setMostraProtestadoDialog(false);
        setProtestoMostrado(true);
        break;
      case "tutorial":
        setMostraTutorial(false);
        break;
      case "atualizarDados":
        setMostraAtualizaDados(false);
        break;
      default:
        break;
    }

    // Atualiza a fila de forma atômica
    setOrdemPopUps((prev) => {
      const nova = prev.filter((item) => item !== popUpAtual);
      console.log("Nova ordem após fechar:", nova);

      // Zera o atual antes de abrir o próximo
      setPopUpAtual(null);

      if (nova.length > 0) {
        const proximo = nova[0];
        setTimeout(() => {
          setPopUpAtual(proximo);
          abrirPopUpEspecifico(proximo);
        }, 50);
      }
      return nova;
    });
  };

  const forcarTutorial = () => {
    console.log("Forçando abertura do tutorial - respeitando ordem");

    const ordemPrioridade = ["notificacao", "protesto", "tutorial", "atualizarDados"];

    // Monta a nova ordem a partir do estado atual, garantindo unicidade
    setOrdemPopUps((prev) => {
      const set = new Set(prev);
      set.add("notificacao");
      set.add("protesto");
      set.add("tutorial");

      const novaOrdem = Array.from(set).sort((a, b) => ordemPrioridade.indexOf(a) - ordemPrioridade.indexOf(b));

      console.log("Nova ordem forçada:", novaOrdem);

      // Abrir imediatamente o primeiro da fila forçada,
      // sem depender de fecharPopUpAtual() (abrirPopUpEspecifico já fecha os demais)
      const primeiro = novaOrdem[0];
      setPopUpAtual(primeiro);
      abrirPopUpEspecifico(primeiro);

      return novaOrdem;
    });
  };

  const abrirTutorialManual = () => {
    // CORREÇÃO: Quando aberto manualmente, não marca como "mostrado" automaticamente
    if (ordemPopUps.includes("tutorial")) {
      setPopUpAtual("tutorial");
      abrirPopUpEspecifico("tutorial");
    } else {
      const novaOrdem = ["tutorial", ...ordemPopUps.filter((item) => item !== "tutorial")];
      setOrdemPopUps(novaOrdem);
      setPopUpAtual("tutorial");
      abrirPopUpEspecifico("tutorial");
    }
  };

  // Funções individuais de fechamento
  const fecharNotificacao = () => {
    setMostraNotificacaoDialog(false);
    setNotificacaoLida(true);
    if (popUpAtual === "notificacao") {
      fecharPopUpAtual();
    } else {
      const novaOrdem = ordemPopUps.filter((item) => item !== "notificacao");
      setOrdemPopUps(novaOrdem);
    }
  };

  const fecharProtesto = () => {
    setMostraProtestadoDialog(false);
    setProtestoMostrado(true);
    if (popUpAtual === "protesto") {
      fecharPopUpAtual();
    } else {
      const novaOrdem = ordemPopUps.filter((item) => item !== "protesto");
      setOrdemPopUps(novaOrdem);
    }
  };

  const fecharTutorial = () => {
    setMostraTutorial(false);
    // CORREÇÃO: Só marca como mostrado se estava na ordem automática
    if (popUpAtual === "tutorial") {
      setTutorialMostrado(true);
      fecharPopUpAtual();
    } else {
      const novaOrdem = ordemPopUps.filter((item) => item !== "tutorial");
      setOrdemPopUps(novaOrdem);
    }
  };

  const fecharAtualizarDados = () => {
    setMostraAtualizaDados(false);
    if (popUpAtual === "atualizarDados") {
      fecharPopUpAtual();
    } else {
      const novaOrdem = ordemPopUps.filter((item) => item !== "atualizarDados");
      setOrdemPopUps(novaOrdem);
    }
  };


  if (!erroConexaoBackEnd)
    return (
      <div
        className={`from-emerald-700 via-emerald-500 to-green-400 bg-gradient-to-tl 
        h-full md:h-screen w-full xl:pb-[4.2vh] lg:pb-[6vh] md:pb-[7vh] pb-[9.5vh]
        grid lg:flex  overflow-x-hidden md:ml-0  text-emerald-900 font-lato-bold `}
        style={{
          backgroundImage: `linear-gradient(to top left,${corGradiente1},${corGradiente2},${corGradiente3})`,
          color: corFonte,
        }}
      >
        {/* <div style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 10000 }}>
          <Button
            icon="pi pi-bug"
            onClick={forcarTutorial}
            tooltip="Forçar Tutorial (Debug)"
            className="p-button-help"
          />
        </div> */}
        <Helmet>
          <title>{tituloPagina}</title>
          <meta name="description" content="Helmet application" />
          <link rel="icon" href={iconePagina} />
          <link rel="apple-touch-icon" href={iconePagina} />
        </Helmet>
        <div className="fixed mt-[1vh] ml-[1vh]  z-50 logoutButton">
          <Button icon="pi pi-arrow-left" className="logoutButton" onClick={() => sair()} tooltip="Sair"></Button>
        </div>
        <SimpleLoading status={loading} />
        {seletorCredor && <ProviderSelector close={() => setSeletorCredor(false)} />}
        {mostraNegociadas && <DialogNegociadas close={() => setMostraNegociadas(false)} />}
        {mostraProtesto && (
          <ProtestoDialog
            close={() => setMostraProtesto(false)}
            aceiteProtesto={(email) => {
              aceitaProtesto(email);
              setMostraProtesto(false);
            }}
          />
        )}
        {mostraTermo && (
          <TermoDialog close={() => setMostraTermo(false)} aceiteTermo={() => aceitaTermo(totalPagar())} />
        )}
        {mostraCartaoCreditoDialog && (
          <CartaoCreditoDialog
            close={() => setMostraCartaoCreditoDialog(false)}
            cartaoValidacao={(data) => cartaoValidacao(data)}
          />
        )}
        {mostraCartaoCreditoLinkDialog && (
          <CartaoCreditoLinkDialog close={() => setMostraCartaoCreditoLinkDialog(false)} />
        )}
        {mostraBandeiraCartaoDialog && (
          <BandeiraCartaoDialog
            close={() => {
              mudaFormaPagamento("B");
              setMostraBandeiraCartaoDialog(false);
            }}
            selecionarBandeira={() => {
              mudaFormaPagamento("C");
              setMostraBandeiraCartaoDialog(false);
            }}
          />
        )}
        {mostraDownloadBoletoDialog && (
          <DownloadBoletoDialog
            close={() => setMostraDownloadBoletoDialog(false)}
            atualizarDados={() => setMostraAtualizaDados(true)}
          />
        )}
        {mostraDetalhesDialog && (
          <DetalhesDialog close={() => setMostraDetalhesDialog(false)} infoCobrancaDetalhe={cobrancaDetalhada} />
        )}

        {mostraNotificacaoDialog && (
          <NotificacaoDialog
            close={fecharNotificacao}
            notificacoes={
              Array.isArray(notificacoes)
                ? notificacoes.filter(
                  (n) => n && !(n.desativar === true || String(n.desativar).toLowerCase() === "true")
                )
                : []
            }
          />
        )}

        {mostraProtestadoDialog && <ProtestadoDialog close={fecharProtesto} tableData={protestadas} />}

        {mostraTutorial && <TutorialDialog close={fecharTutorial} />}

        {mostraAtualizaDados && <AtualizarDadosDialog close={fecharAtualizarDados} />}

        {mostraAtualizaEndereco && <AtualizarEnderecoDialog close={()=>setMostraAtualizaEndereco(false)} next={()=>setMostraTermo(true)} />}

        {mostraInegociavelAvenida && (
          <DialogAvenida close={() => setMostraInegociavelAvenida(false)} sair={() => sair()} />
        )}
        {mostraConfirmacaoAvenida && (
          <DialogConfirmacaoAvenida
            close={() => setMostraConfirmacaoAvenida(false)}
            aceite={() => aceitaTermo()}
            cronograma={cronograma}
            valor_pagamento={totalPagar()}
          />
        )}
        {mostraConfirmacaoDias && (
          <DialogConfirmacaoDias
            close={() => setMostraConfirmacaoDias(false)}
            aceite={() => pagamentoBoleto()}
            cronograma={cronograma}
            valor_pagamento={totalPagar()}
          />
        )}
        {mostraOferta && (
          <DialogOferta close={() => setMostraOferta(false)} ofertaData={oferta.cobrancas} cobrancas={cobrancas} />
        )}
        {mostraContestacao && <ConstestacaoDialog close={() => setMostraContestacao(false)} />}
        {mostraProtestoParcial && (
          <DialogParcialProtestada
            close={() => setMostraProtestoParcial(false)}
            aceiteProtestoParcial={(email) => {
              aceitaProtestoParcial(email);
              setMostraProtestoParcial(false);
            }}
          />
        )}
        <div className="flex lg:flex-row flex-col w-screen gap-[4vh] p-[2vh] md:p-[4vh] mt-[3vh] md:mt-0">
          <div className="w-full h-full flex flex-col gap-[3vh]">
            <div className="w-full  justify-center flex items-center ">
              <div className={`card p-[2vh] w-full h-full bg-emerald-50`} style={{ backgroundColor: corCard1 }}>
                <div className="flex">
                  <h4>
                    Olá, <bdi className="capitalize"> {user.toLowerCase()}</bdi>
                  </h4>
                  {/* <div className="ml-auto">
                    <TutorialSlidesDialog
                      images={sliderImages}
                      buttonProps={{ className: "p-button-text" }}
                      dialogProps={{ appendTo: document.body, baseZIndex: 2000 }}
                    />
                  </div> */}
                  {protestadas.length > 0 && (
                    <div
                      className="hover:cursor-pointer flex justify-center self-center py-1 ml-5 w-[60%] sm:w-[30%] md:w-[25%] lg:w-[25%] xl:w-[20%]"
                      onClick={() => {
                        setMostraProtestadoDialog(true);
                      }}
                      style={{
                        backgroundColor: "#FFB107",
                        borderRadius: 15,
                        borderColor: "white",
                      }}
                    >
                      <div className="flex text-base text-yellow-50">
                        <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "1.4em" }}></i>
                        <b className="">Alerta Protesto!</b>
                      </div>
                    </div>
                  )}
                </div>
                <h6 className="font-lato">{textoConsumidor}</h6>
              </div>
            </div>
            <div className="w-full h-full flex-col lg:flex-row flex gap-[3vh]">
              <div className="w-full lg:w-[65%] h-full justify-center flex items-center">
                <div className={`card p-[2vh] w-full h-full bg-emerald-50 grid`} style={{ backgroundColor: corCard1 }}>
                  <div className="grid md:flex justify-between">
                    {!providerAvenida ? (
                      <h4 className="font-lato-bold">
                        Débitos com
                        <bdi className="capitalize"> {provider}</bdi>
                      </h4>
                    ) : (
                      <h4 className="font-lato-bold">Débitos com Cartão</h4>
                    )}
                    {providerAvenida && (
                      <span
                        className="hover:cursor-pointer"
                        onClick={() => {
                          multiploProvider && setSeletorCredor(true);
                        }}
                      >
                        {logoImage !== pagueDiretoLogo ? (
                          <img src={logoImage} alt="logoCredor" style={{ height: "6vh" }}></img>
                        ) : (
                          <Tag
                            value={provider}
                            style={{
                              backgroundColor: "navy",
                              marginTop: "1vh",
                            }}
                          />
                        )}
                        {multiploProvider && (
                          <p className="text-xs mt-2">
                            <b>Você possui contas com outras empresas, clique aqui para verificar.</b>
                          </p>
                        )}
                      </span>
                    )}
                  </div>
                  {cobrancas.length > 0 && negociacaoParcial && (
                    <div className="block w-full items-center text-center px-[2vh]">
                      <h6>
                        Modalidade de Negociação:
                        <button
                          onClick={abrirTutorialManual}
                          className="rounded-full border-[0.1vh] border-black bg-black text-yellow-400"
                        >
                          <FaQuestionCircle />
                        </button>
                      </h6>
                      <div className=" paymentTypeButton w-full lg:w-full mt-[0.5vh]">
                        <SelectButton
                          value={tipoNegociacao}
                          options={tipoNegociacaoOptions}
                          itemTemplate={botaoTipoPagamento}
                          tooltip={
                            travaNegociacaoTotal &&
                            "A opção está indisponível até a quitação de todas as parcelas da negociação mais recente"
                          }
                          tooltipOptions={{ position: "bottom" }}
                          onChange={(e) => {
                            if (!e.value) {
                              console.log(e.value);
                              return e.value;
                            } else if (e.value === "total") {
                              setDescontoAplicavel(false);
                              processaInfo();
                              setTipoNegociacao(e.value);
                            } else if (e.value === "parcial") {
                              valoresNegociacaoParcial([]);
                              setTipoNegociacao(e.value);
                            }
                            mudaFormaPagamento(null);
                            setCobrancasSelecionadas([]);
                          }}
                        />
                      </div>
                    </div>
                  )}
                  <div className=" mt-[4vh] lg:mt-[3vh] h-[35vh] grid customTable">
                    {cobrancas.length > 0 ? (
                      <DataTable
                        value={cobrancas} //.sort((a, b) => b.dias - a.dias)}
                        scrollable
                        scrollHeight="35vh"
                        selectionMode={null}
                        selection={cobrancasSelecionadas}
                        onSelectionChange={(e) => mudaSelecao(e)}
                        lazy
                        isDataSelectable={(e) => checaMaisAntiga(e)}
                        //responsiveLayout="scroll"
                        breakpoint="900px"
                        onRowClick={(e) => alertaIndisponivel(e)}
                      //scrollDirection="horizontal"
                      >
                        <Column
                          style={{ maxWidth: "40px" }}
                          selectionMode="multiple"
                          hidden={tipoNegociacao === "total"}
                        />
                        {criaColunasCobrancas.map((column, index) => (
                          <Column
                            key={index}
                            header={column.header}
                            field={column.field}
                            // headerStyle={column.header}
                            body={column.body}
                            style={
                              index === 2 &&
                                ((!descontoAplicavel && (descontoTipo === "tempo" || descontoTipo === "porcento")) ||
                                  descontoTipo === "parcela" ||
                                  descontoTipo === "boleto" ||
                                  descontoTipo === "" ||
                                  providerWlan)
                                ? { display: "none" }
                                : column.style
                            }
                          />
                        ))}
                        {!providerAvenida && (
                          <Column
                            header="Detalhes"
                            body={(rowData) => botaoDetalhes(rowData)}
                            style={{
                              textAlign: "center",
                              width: "15%",
                              justifyContent: "center",
                            }}
                          />
                        )}
                      </DataTable>
                    ) : (
                      <h5>
                        {/* Você não possui cobranças com esse credor, parabéns :)<br/> */}
                        Clique no botão abaixo para ver suas negociações anteriores
                      </h5>
                    )}
                  </div>
                  {cobrancas.length > 0 && (
                    <div className="customPaginator">
                      <Paginator
                        first={firstCobrancas}
                        rows={10}
                        totalRecords={countCobrancas}
                        onPageChange={(e) => mudaPagina(e)}
                        template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} de {last} do total de {totalRecords}"
                      ></Paginator>
                    </div>
                  )}
                  {negociadas.length > 0 && (
                    <div className="mt-[3vh] continueButton font-lato">
                      <Button
                        icon={<FaHandshake />}
                        label="Ver Negociações"
                        onClick={() => setMostraNegociadas(true)}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div
                className="w-full lg:w-[35%] h-full grid gap-[2vh]  
                        items-center"
              >
                <div
                  className={`card pb-[0.5vh] pt-[1.5vh] px-[1.5vh] w-full h-full bg-emerald-50`}
                  style={{ backgroundColor: corCard2, color: corFonte2 }}
                >
                  <div className="flex justify-between w-[98%]">
                    <h5>Credor:</h5>
                    <i className="pi pi-users p-overlay-badge" style={{ fontSize: "5vh" }}>
                      {multiploProvider && (
                        <Badge value={"!"} severity="danger" style={{ marginTop: "4px", marginRight: "3px" }}></Badge>
                      )}
                    </i>
                  </div>
                  <span
                    className="hover:cursor-pointer"
                    onClick={() => {
                      multiploProvider && setSeletorCredor(true);
                    }}
                  >
                    {logoImage !== pagueDiretoLogo ? (
                      <img src={logoImage} alt="logoCredor" style={{ height: "6vh" }}></img>
                    ) : (
                      <Tag value={provider} style={{ backgroundColor: "navy", marginTop: "1vh" }} />
                    )}
                    {multiploProvider && (
                      <p className="text-[1.5vh] mt-2">
                        <b>Você possui contas com outras empresas, clique aqui para verificar.</b>
                      </p>
                    )}
                  </span>
                </div>
                <div className={`card p-[1.5vh] w-full h-full`} style={{ backgroundColor: corCard1 }}>
                  <div className="flex justify-between">
                    <h5>Valor Original:</h5>
                    <i className="pi pi-shopping-cart" style={{ fontSize: "5vh" }}></i>
                  </div>
                  <h4>{formatCurrency(providerCREF ? valorOriginal + servicos + taxaEnvioProtesto : valorOriginal)}</h4>
                </div>
                {!providerCREF && !providerCREFDF && (
                  <div className={`card p-[1.5vh] w-full h-full bg-emerald-50`} style={{ backgroundColor: corCard1 }}>
                    <div className="flex justify-between">
                      <h5>Serviços:</h5>
                      <i className="pi pi-info-circle" style={{ fontSize: "5vh" }}></i>
                    </div>
                    <h4>{formatCurrency(servicos)}</h4>
                  </div>
                )}
                <div className={`card p-[1.5vh] w-full h-full bg-emerald-50`} style={{ backgroundColor: corCard1 }}>
                  <div className="flex justify-between">
                    <h5>Juros e Multa:</h5>
                    <i className="pi pi-percentage" style={{ fontSize: "5vh" }}></i>
                  </div>
                  <h4>{formatCurrency(juros + multa + indice)}</h4>
                </div>
                {providerCREFDF && (
                  <div className={`card p-[1.5vh] w-full h-full bg-emerald-50`} style={{ backgroundColor: corCard1 }}>
                    <div className="flex justify-between">
                      <h5>Valor Total:</h5>
                      <i className="pi pi-info-circle" style={{ fontSize: "5vh" }}></i>
                    </div>
                    <h4>{formatCurrency(valorOriginal + juros + multa + indice)}</h4>
                  </div>
                )}
              </div>
            </div>
          </div>
          {cobrancas.length > 0 && (
            <div className="w-full lg:w-1/3 h-full justify-center flex items-center ">
              <div
                className={`card p-[2vh] w-full h-full item bg-emerald-50 grid content-stretch 
                    gap-[2vh]`}
                style={{ backgroundColor: corCard1 }}
              >
                {provider === "Lojas Visão" && !quebrada && (
                  <div
                    className={`h-full w-full p-[1vh] rounded-md 
                        bg-emerald-300 grid text-center content-center
                        `}
                    style={{ backgroundColor: corCard2, color: corFonte2 }}
                  >
                    <div>
                      <h6>Desconto de 50% em pagamento 1x.</h6>
                      <h6>Desconto de 30% demais parcelas.</h6>
                    </div>
                  </div>
                )}
                <div
                  className={`h-full gap-[1.5vh] w-full rounded-md 
                        bg-emerald-300 text-center p-[1vh] grid lg:overflow-auto 
                        ${formaPagamentoAlerta && "blinkPayment"}`}
                  style={{ backgroundColor: corCard2, color: corFonte2 }}
                >
                  <h5>Forma de Pagamento</h5>
                  <div className="paymentTypeButton h-[7vh]">
                    {!bloqueioCartao ? (
                      <SelectButton
                        value={tipoPagamento}
                        options={tipoPagamentoOptions}
                        itemTemplate={botaoTipoPagamento}
                        tooltip={
                          valorAPagar < 30 &&
                          cobrancas.length > 0 &&
                          "A opção de boleto so é valida para negociações de mais de R$ 30,00"
                        }
                        tooltipOptions={{ position: "bottom" }}
                        onChange={(e) => {
                          setFormaPagamentoAlerta(false);
                          setMostraBandeiraCartaoDialog(mudaFormaPagamento(e.value) ? false : true);
                          // setDescontoAplicavel(false);
                          // setParcelaValor({numero_parcela:0,valor_parcela:0});
                        }}
                      />
                    ) : (
                      <div className="uniqueButton justify-center px-[5%]">
                        <Button
                          value="B"
                          onClick={() => {
                            mudaFormaPagamento("B");
                            setFormaPagamentoAlerta(false);
                          }}
                          className="uniqueButton "
                          label="Boleto"
                          icon={<FaBarcode />}
                        />
                      </div>
                    )}
                  </div>
                  {devedorInfo.status_descricao === "FGTS ATIVO" && (
                    <div className="flex justify-center">
                      <button
                        className="gap-[2vh] bg-amber-400 flex justify-between text-center
                      max-h-16 px-[4vh] py-[1.5vh] rounded-md leading-none items-center"
                        onClick={() => openInNewTab("https://wa.me/5511996383405?text=Quero negociar com FGTS")}
                      >
                        <span className="font-lato-bold text-[2vh]">Pague com seu FGTS</span>
                        <i>
                          <FaMoneyBill className="text-[3vh] " />
                        </i>
                      </button>
                    </div>
                  )}
                  {tipoPagamento === "C" && (
                    <div className="flex justify-center ">
                      <button
                        className="uppercase py-[0.2vh] bg-yellow-600 text-white
                                text-[2vh] px-[1vh]
                                flex justify-center items-center gap-[1vh] rounded-md"
                        onClick={() => setMostraBandeiraCartaoDialog(true)}
                      >
                        <FaCreditCard />
                        {cartaoBandeira}
                      </button>
                    </div>
                  )}

                  {false && entradaAceite && tipoPagamento === "B" && !providerAvenida && (
                    <div className="flex justify-center -mb-[2vh] continueButton">
                      <div className="w-[90%]">
                        <Button label="Adicionar Entrada" onClick={(e) => entrada_overlay.current.toggle(e)}></Button>
                        <OverlayPanel
                          ref={entrada_overlay}
                          showCloseIcon
                          id="overlay_panel"
                          style={{ width: "39vh", marginLeft: "5vh" }}
                          className="entradaOverlay"
                        >
                          <div className="grid justify-items-center gap-3 text-center ">
                            <h6 className="font-lato-bold">Valor Entrada</h6>
                            <div className="mt-0">
                              <InputNumber
                                onValueChange={(e) => {
                                  //console.log(e.value);
                                  setEntrada(e.value);
                                  adicionaEntrada(e.value);
                                }}
                                max={valorComDesconto}
                                min={entradaMinima}
                                value={entrada}
                                placeholder="Valor da entrada em R$"
                                mode="currency"
                                currency="BRL"
                              />
                            </div>
                            <h6 className="text-red-700 mt-1">*mínimo de {formatCurrency(entradaMinima)}</h6>
                            <div className="w-[60%] flex justify-between">
                              <Button
                                tooltip="Adicionar"
                                icon="pi pi-plus"
                                onClick={() => {
                                  adicionaEntrada("botao");
                                  entrada_overlay.current.hide();
                                }}
                              ></Button>
                              <Button
                                tooltip="Sem Entrada"
                                onClick={() => {
                                  limpaEntrada();
                                  entrada_overlay.current.hide();
                                }}
                                icon="pi pi-times"
                              ></Button>
                            </div>
                          </div>
                        </OverlayPanel>
                      </div>
                    </div>
                  )}
                  {tipoPagamento && descontoTipo !== "parcela" && (
                    // || tipoPagamento === "C" && <>
                    <>
                      <h5>Número de Parcelas</h5>
                      {(entrada || providerAvenida) && (
                        <div>
                          <h5>Entrada de {formatCurrency(entrada)}</h5>
                          <h5>+</h5>
                        </div>
                      )}
                      <div className="parcelasDropdown -mt-[2vh]">
                        <Dropdown
                          value={parcelaValor}
                          options={parcelas}
                          optionValue="values"
                          scrollHeight="30vh"
                          onChange={(e) => {
                            // setQuantidadeParcelas(e.value.qtd_parcelas);
                            // setParcelaValor(e.value);
                            checaDesconto(e.value);
                            setFormaPagamentoAlerta(false);
                          }}
                          id="parcelas"
                          //virtualScrollerOptions={{ lazy: true}}
                          emptyMessage={
                            <div className="flex justify-center mb-10 mt-10">
                              <ProgressSpinner strokeWidth="6" fill="transparent" animationDuration=".6s" />
                            </div>
                          }
                          placeholder="Selecione aqui"
                        />
                      </div>
                    </>
                  )}
                  {tipoPagamento && descontoTipo === "parcela" && (
                    <>
                      <h6 className="my-[-1vh]">Número de Parcelas</h6>
                      <div className="parcelasDropdown flex justify-between px-[1vh] items-center gap-[0.5vh]">
                        <div className="w-1/2">
                          <Dropdown
                            value={parcelaValor}
                            options={parcelas}
                            optionValue="values"
                            scrollHeight="30vh"
                            onChange={(e) => {
                              // setQuantidadeParcelas(e.value.qtd_parcelas);
                              // setParcelaValor(e.value);
                              checaDesconto(e.value);
                              setFormaPagamentoAlerta(false);
                            }}
                            onInvalid={(e) => {
                              console.log(e);
                            }}
                            id="parcelas"
                            //virtualScrollerOptions={{ lazy: true}}
                            emptyMessage={
                              <div className="flex justify-center mb-10 mt-10">
                                <ProgressSpinner strokeWidth="6" fill="transparent" animationDuration=".6s" />
                              </div>
                            }
                            placeholder="Selecione aqui"
                          />
                        </div>
                        <div className="w-1/2">
                          <h5>{formatCurrency(parcelasDescontoParcelas.valor_parcela)}</h5>
                        </div>
                      </div>
                    </>
                  )}
                  {mostraDescontoVencimentoBoleto && (
                    <>
                      <h6>Data de Vencimento do Boleto</h6>
                      <div className="parcelasVencimentoDropdown">
                        <Dropdown
                          value={boletoVencimentoParcelasValor}
                          options={boletoVencimentoParcelas}
                          optionValue="values"
                          scrollHeight="30vh"
                          onChange={(e) => {
                            checaDescontoBoleto(e.value);
                            setFormaPagamentoAlerta(false);
                          }}
                          id="parcelas_vencimento"
                          //virtualScrollerOptions={{ lazy: true}}
                          emptyMessage={
                            <div className="flex justify-center mb-10 mt-10">
                              <ProgressSpinner strokeWidth="6" fill="transparent" animationDuration=".6s" />
                            </div>
                          }
                          placeholder="Selecione aqui"
                        />
                      </div>
                    </>
                  )}
                  {tipoPagamento === "B" && escolheVencimento && (
                    <div className="grid gap-1">
                      <h6>Data de Vencimento do Boleto</h6>
                      <div className="loginCalendar px-[1vh]">
                        <Calendar
                          value={addDays(today, boletoVencimento)}
                          maxDate={maxVencimento}
                          minDate={today}
                          locale="pt-BR"
                          dateFormat="dd/mm/yy"
                          onChange={handleDataChange}
                          onBlur={handleBlur}
                          placeholder="ex: 21/06/1992"
                          showIcon
                          yearNavigator
                          yearRange="1900:2030"
                          inputMode="number"
                          showOnFocus={false}
                          id="nascimento"
                          required
                          mask="99/99/9999"
                        />
                      </div>
                      {!digitando && erroData && <h7 className="text-red-300 text-sm mt-1">{erroData}</h7>}
                    </div>
                  )}
                </div>
                <div
                  className={`h-full w-full p-[1vh] rounded-md 
                bg-emerald-300 grid text-center
                `}
                  style={{ backgroundColor: corCard2, color: corFonte2 }}
                >
                  {desconto > 0 && descontoAplicavel && (
                    <div>
                      <h5 className="font-lato">Desconto:</h5>
                      <h4>{descontoAplicavel ? formatCurrency(desconto) : "-"}</h4>
                    </div>
                  )}
                  {!providerAvenida && (cobrancasSelecionadas.length > 0 || tipoNegociacao === "total") && (
                    <div>
                      <h6 className="font-lato">Taxa Administrativa:</h6>
                      <h5 className="">
                        {cobrancasSelecionadas.length > 0 || tipoNegociacao === "total"
                          ? formatCurrency(taxaPague())
                          : "-"}
                      </h5>
                    </div>
                  )}
                  {(taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0) > 0 &&
                    parcelaValor.numero_parcela > 0 &&
                    (cobrancasSelecionadas.length > 0 || tipoNegociacao === "total") && (
                      <div>
                        <h6 className="font-lato">Taxa de envio eletrônico:</h6>
                        <h5 className="">{formatCurrency(taxaEnvioProtesto)}</h5>
                      </div>
                    )}
                  {valorBaixa > 0 && totalPagar() > 0 && (
                    <div>
                      <h5 className="font-lato">Abatimentos:</h5>
                      <h4>{totalPagar() > 0 ? formatCurrency(valorBaixa) : "-"}</h4>
                    </div>
                  )}
                  <div>
                    <h5 className="font-lato">Valor a Pagar:</h5>
                    <h4>
                      {(cobrancasSelecionadas.length > 0 || tipoNegociacao === "total") &&
                        parcelaValor.numero_parcela > 0
                        ? formatCurrency(totalPagar())
                        : "-"}
                    </h4>
                  </div>
                </div>
                <div className="items-end grid w-full ">
                  <div
                    className="continueButton"
                    onClick={() => {
                      (totalPagar() <= 0 || parcelaValor.valor_parcela === 0) &&
                        toast.warning(
                          !tipoPagamento
                            ? "Selecione a forma de pagamento para poder continuar"
                            : "Selecione o número de parcelas para poder continuar"
                        );
                      (totalPagar() <= 0 || parcelaValor.valor_parcela === 0) && setFormaPagamentoAlerta(true);
                    }}
                  >
                    <Button
                      label="Continuar"
                      disabled={
                        totalPagar() <= 0 ||
                        parcelaValor.valor_parcela === 0 ||
                        (!providerAvenida && tipoFeeProtesto !== "nenhum" && valorFeeProtesto === 0) ||
                        (boletoVencimentoParcelasValor.length === 0 &&
                          boletoVencimentoParcelas.length > 0 &&
                          tipoPagamento === "boleto")
                      }
                      onClick={() => continuarNegociacao()}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <QuickMenu selected={true} />
        <script
          type="text/javascript"
          src="https://sandbox.boletobancario.com/boletofacil/wro/direct-checkout.min.js"
        ></script>
        {mostrarFooter && <AppFooter />}
      </div>
    );
  else
    return (
      <div
        style={{
          backgroundImage: `linear-gradient(to top left,${corGradiente1},${corGradiente2},${corGradiente3})`,
          color: corFonte,
        }}
      >
        <Helmet>
          <title>{tituloPagina}</title>
          <link rel="icon" href={iconePagina} />
          <link rel="apple-touch-icon" href={iconePagina} />
          <meta name="description" content="Helmet application" />
        </Helmet>
        <ErrorPage logo={pagueDiretoLogo} />
      </div>
    );
}

export default Dashboard;
